import React, { PropsWithChildren, useMemo } from 'react';
import { RoboScreener } from '../Components/Roboscreener';

export type RoboScreenerContextType = {
  roboscreener: RoboScreener | null;
};

export const RoboScreenerContext = React.createContext<RoboScreenerContextType>({ roboscreener: null });

export const useRoboScreener = () => {
  const context = React.useContext(RoboScreenerContext);
  return context;
};

type RoboScreenerProviderProps = {
  roboscreener: RoboScreener | null;
};

export const RoboScreenerProvider: React.FC<PropsWithChildren<RoboScreenerProviderProps>> = ({ children, roboscreener }) => {
  const value = useMemo(() => ({ roboscreener }), [roboscreener]);
  
  return (
    <RoboScreenerContext.Provider value={value}>
      {children}
    </RoboScreenerContext.Provider>
  );
};

